import AbstractException from '../AbstractException.js';
import ExceptionTypeEnum from '../enums/ExceptionTypeEnum.js';
/**
 * Custom exception.
 */
export default class ComponentElementException extends AbstractException {
    /**
     * Class constructor.
     *
     * @param element Element.
     * @param message The error message.
     */
    constructor(element, message) {
        super(element.tagName + ' => ' + message);
        this.exceptionType = ExceptionTypeEnum.componentElement;
        this.name = 'ComponentElementException';
        this.elementTagName = element.tagName;
    }
}
//# sourceMappingURL=ComponentElementException.js.map